import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { reduce } from 'lodash-es';
import { APP_ENV_CONFIG } from '@shared/services';
import { FeatureFlag } from '@shared/models';
import { FeatureFlagActions } from './feature-flag.actions';
import { AuthActions } from '../auth-feature';
import { featureList } from './feature-flag.state';

export const loadBusinessAccountDetails$ = createEffect(
  (actions$ = inject(Actions), envConfig = inject(APP_ENV_CONFIG)) => {
    return actions$.pipe(
      ofType(AuthActions.authLogin, FeatureFlagActions.resetFeatureFlags),
      map(() => {
        const envName = envConfig.name;

        const featureFlags = reduce(
          featureList,
          (result: FeatureFlag, value, key) => {
            return { ...result, [key]: value.environments.includes(envName) };
          },
          {},
        );

        return FeatureFlagActions.setFeatureFlags({ featureFlags });
      }),
    );
  },
  { functional: true },
);
